var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBtnNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46967 15.0305C5.17678 14.7377 5.17678 14.2628 5.46967 13.9699L11.3893 8.05022L5.46967 2.13055C5.17678 1.83766 5.17678 1.36278 5.46967 1.06989C5.76256 0.776996 6.23744 0.776996 6.53033 1.06989L12.9803 7.51989C13.2732 7.81278 13.2732 8.28766 12.9803 8.58055L6.53033 15.0305C6.23744 15.3234 5.76256 15.3234 5.46967 15.0305Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBtnNext);
export default __webpack_public_path__ + "static/media/ic_btn_next.046ef5ed6476bb43b0aaca85e2d4f1fa.svg";
export { ForwardRef as ReactComponent };